import { Component, ComponentFactoryResolver, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { PortadaComponent } from 'src/app/shared/widgets/portada/portada.component';

import { environment } from 'src/environments/environment';
import { BuscadorCarrerasComponent } from '../../components/buscador-carreras/buscador-carreras.component';
import { FormasDeContactoDosComponent } from 'src/app/shared/widgets/formas-de-contacto/formas-de-contacto-dos.component';
import { NuestrasSedesComponent } from 'src/app/shared/widgets/nuestras-sedes/nuestras-sedes.component';
import { SliderComponent } from 'src/app/shared/widgets/slider/slider.component';
import { TextItemGeneralComponent } from 'src/app/shared/widgets/text-item-general/text-item-general.component';
import { CodeQRComponent } from 'src/app/modules/general/components/code-qr/code-qr.component';
import { ServicesComponent } from 'src/app/modules/general/components/services/services.component';
import { VenuesComponent } from 'src/app/shared/widgets/venues/venues.component';
import { FormasDeContactoTresComponent } from 'src/app/shared/widgets/formas-de-contacto-tres/formas-de-contacto-tres.component';
import { LoaderService } from 'src/app/core/load/load.service';
import { PortadaIncripcionesComponent } from 'src/app/shared/widgets/portada-incripciones/portada-incripciones.component';
import { ContenidoIncripcionesComponent } from 'src/app/shared/widgets/contenido-incripciones/contenido-incripciones.component';
import { DepartamentosIncripcionesComponent } from 'src/app/shared/widgets/departamentos-incripciones/departamentos-incripciones.component';
import { lastValueFrom, take } from 'rxjs';


@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.scss'],
})
export class IngresoComponent implements OnInit {

  @ViewChildren('dynamicContainer', { read: ViewContainerRef }) containers!: QueryList<ViewContainerRef>;
  @ViewChildren('lazyWrapper', { read: ElementRef }) wrappers!: QueryList<ElementRef>;
  pages: any[] = [1, 2, 3];
  nextIndex = 0;

  apiUrl: any;
  id: any;
  id_component: string;
  language: string;

  sede: any;
  refBuscador: any;


  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public meta: Meta,
    public services: GeneralService,
    private loader: LoaderService,) {
    this.loader.setLoading(true);
    this.opcionsUrl();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.clearUrl();

    this.services.getSimplepage(this.id, this.language).subscribe(res => {
      this.sede = res.data[0].region;
      if (this.sede) {
        $(".ingreso-container").css("background-image", 'none');
      }

      // Convertimos el objeto de páginas en un array
      this.pages = Object.keys(res.data[0].pages)
        .filter(key => !isNaN(Number(key)))
        .map(key => res.data[0].pages[key][0]);

      // 🔹 Pre-cargar entidades
      this.preloadEntities().then(() => {
        // 🔹 Cuando todas estén listas, iniciar lazy load
        setTimeout(() => this.initSequentialLazyLoad(), 0);
      });
    });
  }

  preloadedData: any;
  preloadEntities(): Promise<void> {
    const requests = this.pages.map(page => {
      const url = page.route + '&locale=' + this.language;

      return lastValueFrom(
        this.services.getEntities(url).pipe(take(1))
      ).catch(error => {
        console.error(`Error cargando la ruta: ${url}`, error);
        return null;
      });
    });

    return Promise.all(requests).then(results => {
      this.preloadedData = results;
    }).catch(err => {
      console.error("Error crítico en Promise.all:", err);
    });
  }


  initSequentialLazyLoad() {
    // Asegurarse de que nextIndex arranca en 0
    this.nextIndex = 0;

    const wrappersArray = this.wrappers.toArray();

    const loadNext = (index: number) => {
      if (index >= this.pages.length) {
        this.loader.setLoading(false);
        return
      };

      const wrapper = wrappersArray[index];
      if (!wrapper) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Cargar datos
            const page = this.pages[index];
            const data = this.preloadedData[index];
            this.newComponent(index, page.entityType, data);
            // Fade-in al aparecer
            const currentWrapper = wrappersArray[index].nativeElement;
            currentWrapper.classList.add('loaded');
            (currentWrapper as HTMLElement).style.minHeight = "0px";


            // Avanzar al siguiente
            loadNext(index + 1);


            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0 }); // threshold 0 para disparar apenas aparece

      observer.observe(wrapper.nativeElement);
    };

    // arrancamos con el primero
    loadNext(this.nextIndex);
  }


  newComponent(index: number, type: string, info: any) {
    const container = this.containers.toArray()[index]; // obtenemos el ViewContainerRef correspondiente
    let ref: any;
    let factory;

    switch (type) {

      case "PortadaSedes":
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0];
        ref.instance.marginTitle = 40;
        ref.instance.heightDesk = "525px";
        ref.instance.heightMob = "370px";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;
        break;

      case "Portada":
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0];
        ref.instance.marginTitle = 75;
        ref.instance.heightDesk = "";
        ref.instance.heightMob = "";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;
        break;

      case 'Buscador':
        factory = this.componentFactoryResolver.resolveComponentFactory(BuscadorCarrerasComponent);
        ref = container.createComponent(factory);
        this.refBuscador = ref;
        this.refBuscador.instance.data = info.data;
        this.refBuscador.instance.translateY = (this.sede) ? "50%" : "52%";
        this.refBuscador.instance.padding = "30px 35.6px 30px 35.6px";
        if (this.sede) this.refBuscador.instance.showPagination = false;
        this.activatedRoute.params.forEach((params: Params) => {
          this.sede = params['id'];
          this.refBuscador.instance.sede = this.sede?.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        });
        this.refBuscador.changeDetectorRef.detectChanges();
        break;

      case "Contacto":
        factory = this.componentFactoryResolver.resolveComponentFactory(FormasDeContactoDosComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data;
        ref.instance.esCurso = false;
        break;

      case "Headquarters":
        factory = this.componentFactoryResolver.resolveComponentFactory(NuestrasSedesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].headquarters;
        ref.instance.sedes = info.data[0].sedes;
        break;

      case "ImageSlider":
        factory = this.componentFactoryResolver.resolveComponentFactory(SliderComponent);
        ref = container.createComponent(factory);
        ref.instance.marginDesk = info.data[0].image.margin_desktop;
        ref.instance.marginMob = info.data[0].image.margin_mobile;
        ref.instance.images = info.data[0].image[0];
        break;

      case 'TextItem':
        factory = this.componentFactoryResolver.resolveComponentFactory(TextItemGeneralComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.title;
        ref.instance.i = index;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'InscriptionQr':
        factory = this.componentFactoryResolver.resolveComponentFactory(CodeQRComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].inscriptionQr;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'Services':
        factory = this.componentFactoryResolver.resolveComponentFactory(ServicesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].benefitsButtons;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'VenueWidget':
        factory = this.componentFactoryResolver.resolveComponentFactory(VenuesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].venueWidget;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'ContactFormSede':
        factory = this.componentFactoryResolver.resolveComponentFactory(FormasDeContactoTresComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].contactFormSede;
        ref.instance.blue = true;
        ref.changeDetectorRef.detectChanges();
        break;


      case 'CoverInscriptions':
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaIncripcionesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info?.data[0]?.coverInscriptions;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'InscriptionContent':
        factory = this.componentFactoryResolver.resolveComponentFactory(ContenidoIncripcionesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info?.data[0]?.inscriptionContent;
        ref.changeDetectorRef.detectChanges();
        break;

      case 'DepartmentInscription':
        factory = this.componentFactoryResolver.resolveComponentFactory(DepartamentosIncripcionesComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data[0].departmentInscription;
        ref.changeDetectorRef.detectChanges();
        break;
    }
  }
  clearUrl() {
    let relativeUrl = this.router.url.split('?')[0];
    const language = this.activatedRoute.snapshot.params['language'];
    if (language) {
      relativeUrl = relativeUrl.replace(`/${language}/`, '/').replace(`/${language}`, '/');
    }
    this.id = relativeUrl.startsWith('/') ? relativeUrl.substring(1) : relativeUrl;
  }
  opcionsUrl() {
    this.apiUrl = environment.apiUrl;
    this.language = (this.activatedRoute.snapshot.params['language']) ? this.activatedRoute.snapshot.params['language'] : 'es';
    this.id_component = this.activatedRoute.snapshot.params['id'];
    let url = window.location.href;
    if (url.includes('#')) {
      let l = (this.activatedRoute.snapshot.params['language']) ? "/" + this.activatedRoute.snapshot.params['language'] : 'es';
      let index = url.indexOf("#")
      let palabra = url.slice((index + 1), url.length)
      window.location.href = l + "/busqueda/ingreso#" + palabra;
    }
  }
}
